import { httpClient } from "./httpClient";

const BASE = "/api/notificaciones";

const listar = () => httpClient.get(`${BASE}`);
const marcarLeida = (id) => httpClient.put(`${BASE}/${id}/leida`);
const marcarTodas = () => httpClient.put(`${BASE}/leidas`);
const eliminar = (id) => httpClient.del(`${BASE}/${id}`);

const notificacionesService = {
  listar,
  marcarLeida,
  marcarTodas,
  eliminar,
};

export default notificacionesService;